// extracted by mini-css-extract-plugin
export var statItem = "_ji-1";
export var statsRow = "_ji-0";